import { render, staticRenderFns } from "./MotionController.vue?vue&type=template&id=9dcf17fe&scoped=true&"
import script from "./MotionController.vue?vue&type=script&lang=js&"
export * from "./MotionController.vue?vue&type=script&lang=js&"
import style0 from "./MotionController.vue?vue&type=style&index=0&id=9dcf17fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcf17fe",
  null
  
)

export default component.exports